export enum VendaStatus {
	AGENDADO = <any>'agendado',
	INICIADO = <any>'iniciado',
	EM_ANDAMENTO = <any>'em_andamento',
	PAGAMENTO_PROCESSADO = <any>'pagamento_processado'
}
